module.exports = __webpack_public_path__ + "img/MufasaDasEisUndIch.c65fc95f.svg";